import React from "react";
import { Route, Routes } from "react-router-dom";
import Login from "../Pages/Auth/Login/Login";
import Forgot from "../Pages/Auth/Forgot/Forgot";
import DashboardRoutes from "./DashboardRoutes";
import EditpageLink from "../Pages/All/PageLinks/EditPageLinks/EditpageLink";
import AddPageLinks from "../Pages/All/PageLinks/AddPageLinks/AddPageLinks";
import AddProduct from "../Pages/All/Product/AddProduct/AddProduct";
import AddWorkoutPlans from "../Pages/All/Workout/WorkoutPlans/AddWorkoutPlans";
import AddRecipePlans from "../Pages/All/Workout/RecipePlans/AddRecipePlans";
import AddVoucher from "../Pages/All/Voucher/AddVoucher";
import PrivateRoute from "../ContextProvider/PrivateRoute";
import SingleProduct from "../Pages/All/Product/SingleProduct/SingleProduct";
import EditProuct from "../Pages/All/Product/EditProduct/EditProduct";
import AddCoupon from "../Pages/All/Coupon/AddCoupon";
import EditVoucher from "../Pages/All/Voucher/SingleVoucher/EditVoucher/EditVoucher";
import SingleCoupon from "../Pages/All/Coupon/SingleCoupon";
import EditCoupon from "../Pages/All/Coupon/EditCoupon";
import UserDetails from "../Pages/All/Users/UserDetails";
import SingleWorkoutPlans from "../Pages/All/Workout/WorkoutPlans/SingleWorkoutPlans";
import EditWorkoutPlans from "../Pages/All/Workout/WorkoutPlans/EditWorkoutPlans";
import SingleRecipe from "../Pages/All/Workout/RecipePlans/SingleRecipe";
import EditRecipe from "../Pages/All/Workout/RecipePlans/EditRecipe";
import AddWeeklyChallenges from "../Pages/All/Workout/WeeklyChallanges/AddWeeklyChallenges";
import SingleChallenge from "../Pages/All/Workout/WeeklyChallanges/SingleChallenge";
import EditChallenge from "../Pages/All/Workout/WeeklyChallanges/EditChallenge";
import SingleDiet from "../Pages/All/Workout/DietPlans/SingleDiet";
import AddDietPlans from "../Pages/All/Workout/DietPlans/AddDietPlans";
import SingleQuestion from "../Pages/All/Workout/Q&A/SingleQuestion";
import AddQuestions from "../Pages/All/Workout/Q&A/AddQuestions";
import EditQuestions from "../Pages/All/Workout/Q&A/EditQuestions";
import EditService from "../Pages/All/PageLinks/EditServices/EditService";
import EditDietPlans from "../Pages/All/Workout/DietPlans/EditDietPlans";
import OrderDetails from "../Pages/All/Order/OrderDetails";
import AddController from "../Pages/All/Controller/AddController";
import EditController from "../Pages/All/Controller/EditController";
import SingleSubAdmin from "../Pages/All/Controller/SingleSubAdmin";

const AllRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot" element={<Forgot />} />

      {/* private routes */}
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <DashboardRoutes />
          </PrivateRoute>
        }
      />
      <Route
        path="/editpagelinks/:id"
        element={
          <PrivateRoute>
            <EditpageLink />
          </PrivateRoute>
        }
      />
      <Route
        path="/editchallenge/:id"
        element={
          <PrivateRoute>
            <EditChallenge />
          </PrivateRoute>
        }
      />
      <Route
        path="/usedetails/:id"
        element={
          <PrivateRoute>
            <UserDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/orderdetails/:id"
        element={
          <PrivateRoute>
            <OrderDetails />
          </PrivateRoute>
        }
      />
      <Route
        path="/editsubadmin/:id"
        element={
          <PrivateRoute>
            <EditController />
          </PrivateRoute>
        }
      />
      <Route
        path="/singlesubadmin/:id"
        element={
          <PrivateRoute>
            <SingleSubAdmin />
          </PrivateRoute>
        }
      />
      <Route
        path="/addcontroller"
        element={
          <PrivateRoute>
            <AddController />
          </PrivateRoute>
        }
      />
      <Route
        path="/SingleWorkoutplans/:id"
        element={
          <PrivateRoute>
            <SingleWorkoutPlans />
          </PrivateRoute>
        }
      />
      <Route
        path="/singlerecipe/:id"
        element={
          <PrivateRoute>
            <SingleRecipe />
          </PrivateRoute>
        }
      />
      <Route
        path="/editrecipeplans/:id"
        element={
          <PrivateRoute>
            <EditRecipe />
          </PrivateRoute>
        }
      />
      <Route
        path="/EditWorkoutplans/:id"
        element={
          <PrivateRoute>
            <EditWorkoutPlans />
          </PrivateRoute>
        }
      />
      <Route
        path="/editproduct/:id"
        element={
          <PrivateRoute>
            <EditProuct />
          </PrivateRoute>
        }
      />
      <Route
        path="addchallenges"
        element={
          <PrivateRoute>
            <AddWeeklyChallenges />
          </PrivateRoute>
        }
      />
      <Route
        path="addcoupon"
        element={
          <PrivateRoute>
            <AddCoupon />
          </PrivateRoute>
        }
      />
      <Route
        path="productdetails/:id"
        element={
          <PrivateRoute>
            <SingleProduct />
          </PrivateRoute>
        }
      />
      <Route
        path="voucherdetails/:id"
        element={
          <PrivateRoute>
            <EditVoucher />
          </PrivateRoute>
        }
      />
      <Route
        path="editcoupon/:id"
        element={
          <PrivateRoute>
            <EditCoupon />
          </PrivateRoute>
        }
      />
      <Route
        path="coupondetails/:id"
        element={
          <PrivateRoute>
            <SingleCoupon />
          </PrivateRoute>
        }
      />
      <Route
        path="singlechallenge/:id"
        element={
          <PrivateRoute>
            <SingleChallenge />
          </PrivateRoute>
        }
      />
      <Route
        path="singlediet/:id"
        element={
          <PrivateRoute>
            <SingleDiet />
          </PrivateRoute>
        }
      />
      <Route
        path="questiondetails/:id"
        element={
          <PrivateRoute>
            <SingleQuestion />
          </PrivateRoute>
        }
      />

      <Route
        path="/addquestion"
        element={
          <PrivateRoute>
            <AddQuestions />
          </PrivateRoute>
        }
      />
      <Route
        path="/editquestion/:id"
        element={
          <PrivateRoute>
            <EditQuestions />
          </PrivateRoute>
        }
      />

      <Route
        path="/Editdietplans/:id"
        element={
          <PrivateRoute>
            <EditDietPlans />
          </PrivateRoute>
        }
      />
      <Route
        path="/editservice/:id"
        element={
          <PrivateRoute>
            <EditService />
          </PrivateRoute>
        }
      />

      <Route
        path="/addpagelinks"
        element={
          <PrivateRoute>
            <AddPageLinks />
          </PrivateRoute>
        }
      />

      <Route
        path="/adddietplans"
        element={
          <PrivateRoute>
            <AddDietPlans />
          </PrivateRoute>
        }
      />
      <Route
        path="/addproduct"
        element={
          <PrivateRoute>
            <AddProduct />
          </PrivateRoute>
        }
      />
      <Route
        path="/addworkoutplans"
        element={
          <PrivateRoute>
            <AddWorkoutPlans />
          </PrivateRoute>
        }
      />
      <Route
        path="/addrecipeplans"
        element={
          <PrivateRoute>
            <AddRecipePlans />
          </PrivateRoute>
        }
      />
      <Route
        path="/adddietplans"
        element={
          <PrivateRoute>
            <AddDietPlans />
          </PrivateRoute>
        }
      />
      <Route
        path="/addvoucher"
        element={
          <PrivateRoute>
            <AddVoucher />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export default AllRoutes;
